import { settings } from 'config';
import { getItemFromStore } from 'helpers/utils';
import c from 'util/const';

export const ORG_ADMIN_NAVBAR_STYLE = 'inverted';

export const isOrgAdmin = userRoles =>
  Array.isArray(userRoles) && userRoles.includes(c.roles.TENANT_ADMIN);

export const getDefaultNavbarStyle = userRoles =>
  isOrgAdmin(userRoles) ? ORG_ADMIN_NAVBAR_STYLE : settings.navbarStyle;

export const hasNavbarStylePreference = () =>
  localStorage.getItem('navbarStyle') !== null;

export const resolveNavbarStyle = (userRoles = []) => {
  if (hasNavbarStylePreference()) {
    return getItemFromStore('navbarStyle', settings.navbarStyle);
  }
  return getDefaultNavbarStyle(userRoles);
};
